export default __webpack_public_path__ + "static/media/BugCatcherView.9deb3450.png";